/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { map } from 'rxjs/operators';
import { JsonReferencesResolver } from './shared/tcc.json-references-resolver';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ClientApiBase {

  static jsonReferencesResolver = new JsonReferencesResolver();

  constructor() {

  }

  /**
   * will resolve any references
   */
  protected transformResult<T>(url: string, response: any, processor: (response: any) => Observable<T>) {
    return processor(response).pipe(map(x => ClientApiBase.jsonReferencesResolver.resolveReferences(x)));
  }

}

@Injectable()
export class ClientApi extends ClientApiBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    
  /** If group 7 matches is UTC, if 8 match is DateTime with Offset, else just a plain old DateTime */
  private static reDt = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:(Z)|([+\-])(\d{2}):(\d{2}))?$/;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    super();
    this.http = http;
    this.baseUrl = baseUrl ?? '';
    this.jsonParseReviver = (key: string, value: any) => {
      if (typeof value === 'string') {
        var m = ClientApi.reDt.exec(value);
        if (m) {
          if (m[7] !== undefined) {
            // UTC
            return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]));
          }
          else if (m[8] !== undefined) {
            // DateTimeOffset
            const dt = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]);
            const negationFactor = (m[8] === '-') ? -1 : 1;
            const originalTimeZoneOffset = (+m[9]) * 60 * negationFactor + +m[10] * negationFactor;
            const minutesDifference = dt.getTimezoneOffset() + originalTimeZoneOffset;
            if (minutesDifference !== 0) {
              dt.setTime(dt.getTime() - minutesDifference * 60 * 1000);
            }
            return dt;
          }
          else {
            // Regular DateTime
            return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]);
          }
        }
      }
      return value;
    }
  }

    /**
     * @return Success
     */
    deleteApplicationView(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/deleteApplicationView/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteApplicationView(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteApplicationView(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteApplicationView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteApplicationViews(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/deleteApplicationViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteApplicationViews(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteApplicationViews(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteApplicationViews(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicationViews(): Observable<ApplicationViewsResource[]> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/getapplicationviews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetApplicationViews(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetApplicationViews(<any>r));
                } catch (e) {
                    return <Observable<ApplicationViewsResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationViewsResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationViews(response: HttpResponseBase): Observable<ApplicationViewsResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApplicationViewsResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationViewsResource[]>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicationView(id: number): Observable<ApplicationViewsResource> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/getapplicationview/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetApplicationView(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetApplicationView(<any>r));
                } catch (e) {
                    return <Observable<ApplicationViewsResource>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationViewsResource>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationView(response: HttpResponseBase): Observable<ApplicationViewsResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApplicationViewsResource>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationViewsResource>(<any>null);
    }

    /**
     * @return Success
     */
    getLedgersForList(): Observable<LedgerResource[]> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/getledgersforlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetLedgersForList(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetLedgersForList(<any>r));
                } catch (e) {
                    return <Observable<LedgerResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLedgersForList(response: HttpResponseBase): Observable<LedgerResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerResource[]>(<any>null);
    }

    /**
     * @return Success
     */
    getViewInfos(): Observable<ViewInfoResource[]> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/getViewInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetViewInfos(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetViewInfos(<any>r));
                } catch (e) {
                    return <Observable<ViewInfoResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewInfoResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetViewInfos(response: HttpResponseBase): Observable<ViewInfoResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ViewInfoResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewInfoResource[]>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicationViewsByCategory(view: string): Observable<ApplicationViewsResource[]> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/getapplicationviewsbycategory/{view}";
        if (view === undefined || view === null)
            throw new Error("The parameter 'view' must be defined.");
        url_ = url_.replace("{view}", encodeURIComponent("" + view));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetApplicationViewsByCategory(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetApplicationViewsByCategory(<any>r));
                } catch (e) {
                    return <Observable<ApplicationViewsResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationViewsResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationViewsByCategory(response: HttpResponseBase): Observable<ApplicationViewsResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApplicationViewsResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationViewsResource[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putApplicationView(body: ApplicationViewsResource | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/putapplicationview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutApplicationView(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutApplicationView(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutApplicationView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putApplicationViews(body: ApplicationViewsResource[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/putapplicationviews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutApplicationViews(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutApplicationViews(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutApplicationViews(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putViewInfo(body: ViewInfoResource | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/applicationViews/putviewinfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutViewInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutViewInfo(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutViewInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Deletes are estimates by estimateType
     * @param estimateType (optional) 
     * @param appliedOn (optional) 
     * @return Success
     */
    deleteRevenueAreaEstimates(orgId: number, revAreaId: number, estimateType: EstimateType | undefined, appliedOn: Date | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/revenueareas/{revAreaId}/estimates?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (revAreaId === undefined || revAreaId === null)
            throw new Error("The parameter 'revAreaId' must be defined.");
        url_ = url_.replace("{revAreaId}", encodeURIComponent("" + revAreaId));
        if (estimateType === null)
            throw new Error("The parameter 'estimateType' cannot be null.");
        else if (estimateType !== undefined)
            url_ += "estimateType=" + encodeURIComponent("" + estimateType) + "&";
        if (appliedOn === null)
            throw new Error("The parameter 'appliedOn' cannot be null.");
        else if (appliedOn !== undefined)
            url_ += "appliedOn=" + encodeURIComponent(appliedOn ? "" + appliedOn.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteRevenueAreaEstimates(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteRevenueAreaEstimates(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRevenueAreaEstimates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Updates or inserts an estimate
     * @param body (optional) 
     * @return Success
     */
    postRevenueAreaEstimate(orgId: number, revAreaId: number, body: Estimate | undefined): Observable<Estimate> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/revenueareas/{revAreaId}/estimates";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (revAreaId === undefined || revAreaId === null)
            throw new Error("The parameter 'revAreaId' must be defined.");
        url_ = url_.replace("{revAreaId}", encodeURIComponent("" + revAreaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRevenueAreaEstimate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRevenueAreaEstimate(<any>r));
                } catch (e) {
                    return <Observable<Estimate>><any>_observableThrow(e);
                }
            } else
                return <Observable<Estimate>><any>_observableThrow(response_);
        }));
    }

    protected processPostRevenueAreaEstimate(response: HttpResponseBase): Observable<Estimate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Estimate>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Estimate>(<any>null);
    }

    /**
     * Gets an estimateValue by id
     * @return Success
     */
    getEstimate(orgId: number, estimateId: number): Observable<Estimate> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/estimates/{estimateId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (estimateId === undefined || estimateId === null)
            throw new Error("The parameter 'estimateId' must be defined.");
        url_ = url_.replace("{estimateId}", encodeURIComponent("" + estimateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEstimate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEstimate(<any>r));
                } catch (e) {
                    return <Observable<Estimate>><any>_observableThrow(e);
                }
            } else
                return <Observable<Estimate>><any>_observableThrow(response_);
        }));
    }

    protected processGetEstimate(response: HttpResponseBase): Observable<Estimate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Estimate>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Estimate>(<any>null);
    }

    /**
     * Gets all areas in a budget year
     * @return Success
     */
    getRevenueAreas(orgId: number, budgetYear: number): Observable<RevenueArea[]> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/budgets/{budgetYear}/revenueareas";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (budgetYear === undefined || budgetYear === null)
            throw new Error("The parameter 'budgetYear' must be defined.");
        url_ = url_.replace("{budgetYear}", encodeURIComponent("" + budgetYear));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRevenueAreas(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRevenueAreas(<any>r));
                } catch (e) {
                    return <Observable<RevenueArea[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevenueArea[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRevenueAreas(response: HttpResponseBase): Observable<RevenueArea[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RevenueArea[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevenueArea[]>(<any>null);
    }

    /**
     * Gets area by id
     * @return Success
     */
    getRevenueAreaById(orgId: number, revAreaId: number): Observable<RevenueArea> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/revenueareas/{revAreaId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (revAreaId === undefined || revAreaId === null)
            throw new Error("The parameter 'revAreaId' must be defined.");
        url_ = url_.replace("{revAreaId}", encodeURIComponent("" + revAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRevenueAreaById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRevenueAreaById(<any>r));
                } catch (e) {
                    return <Observable<RevenueArea>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevenueArea>><any>_observableThrow(response_);
        }));
    }

    protected processGetRevenueAreaById(response: HttpResponseBase): Observable<RevenueArea> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RevenueArea>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevenueArea>(<any>null);
    }

    /**
     * Gets the root areas for organizations
     * @return Success
     */
    getOrganizationAreas(budgetYear: number): Observable<RevenueArea[]> {
        let url_ = this.baseUrl + "/api/v1/estimates/budgets/{budgetYear}/organizationAreas";
        if (budgetYear === undefined || budgetYear === null)
            throw new Error("The parameter 'budgetYear' must be defined.");
        url_ = url_.replace("{budgetYear}", encodeURIComponent("" + budgetYear));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrganizationAreas(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrganizationAreas(<any>r));
                } catch (e) {
                    return <Observable<RevenueArea[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevenueArea[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationAreas(response: HttpResponseBase): Observable<RevenueArea[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RevenueArea[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevenueArea[]>(<any>null);
    }

    /**
     * Gets a rollup for all org estimates for a gives appliedOn date.
     * @param appliedOn (optional) 
     * @return Success
     */
    getRollup(budgetYear: number, appliedOn: Date | undefined): Observable<EstimateAggregation[]> {
        let url_ = this.baseUrl + "/api/v1/estimates/budgets/{budgetYear}/rollups?";
        if (budgetYear === undefined || budgetYear === null)
            throw new Error("The parameter 'budgetYear' must be defined.");
        url_ = url_.replace("{budgetYear}", encodeURIComponent("" + budgetYear));
        if (appliedOn === null)
            throw new Error("The parameter 'appliedOn' cannot be null.");
        else if (appliedOn !== undefined)
            url_ += "appliedOn=" + encodeURIComponent(appliedOn ? "" + appliedOn.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRollup(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRollup(<any>r));
                } catch (e) {
                    return <Observable<EstimateAggregation[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EstimateAggregation[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRollup(response: HttpResponseBase): Observable<EstimateAggregation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EstimateAggregation[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EstimateAggregation[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertPricingBulk(body: InsertPricingResource[] | undefined): Observable<InsertPricingResult[]> {
        let url_ = this.baseUrl + "/api/v1/estimates/insertPricingBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processInsertPricingBulk(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processInsertPricingBulk(<any>r));
                } catch (e) {
                    return <Observable<InsertPricingResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsertPricingResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processInsertPricingBulk(response: HttpResponseBase): Observable<InsertPricingResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InsertPricingResult[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsertPricingResult[]>(<any>null);
    }

    /**
     * Updates or inserts a batch of estimates
     * @param body (optional) 
     * @return Success
     */
    postRevenueAreaEstimateBatch(orgId: number, body: EstimateBatchItem[] | undefined): Observable<RevenueAreaEstimate[]> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/estimateBatches";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRevenueAreaEstimateBatch(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRevenueAreaEstimateBatch(<any>r));
                } catch (e) {
                    return <Observable<RevenueAreaEstimate[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevenueAreaEstimate[]>><any>_observableThrow(response_);
        }));
    }

    protected processPostRevenueAreaEstimateBatch(response: HttpResponseBase): Observable<RevenueAreaEstimate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <RevenueAreaEstimate[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevenueAreaEstimate[]>(<any>null);
    }

    /**
     * Receives renewal offers uploaded for an organization.
     * @param body (optional) 
     * @return Success
     */
    postRenewalOffers(orgId: number, body: RenewalOfferUploadItem[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/renewalOffers";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRenewalOffers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRenewalOffers(<any>r));
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostRenewalOffers(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Updates or inserts an estimate
     * @param body (optional) 
     * @return Success
     */
    postRevenueAreaMeta(orgId: number, revAreaId: number, body: RevenueAreaMeta | undefined): Observable<RevenueAreaMeta> {
        let url_ = this.baseUrl + "/api/v1/estimates/organizations/{orgId}/revenueareas/{revAreaId}/meta";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (revAreaId === undefined || revAreaId === null)
            throw new Error("The parameter 'revAreaId' must be defined.");
        url_ = url_.replace("{revAreaId}", encodeURIComponent("" + revAreaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRevenueAreaMeta(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRevenueAreaMeta(<any>r));
                } catch (e) {
                    return <Observable<RevenueAreaMeta>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevenueAreaMeta>><any>_observableThrow(response_);
        }));
    }

    protected processPostRevenueAreaMeta(response: HttpResponseBase): Observable<RevenueAreaMeta> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <RevenueAreaMeta>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevenueAreaMeta>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fpInstaller(body: string[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/fpinstaller/fpInstaller";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processFpInstaller(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFpInstaller(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processFpInstaller(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    fpInstallerStatus(): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/fpinstaller/fpInstallerStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processFpInstallerStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFpInstallerStatus(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processFpInstallerStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    installpayrollallowances(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/fpinstaller/installpayrollallowances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processInstallpayrollallowances(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processInstallpayrollallowances(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processInstallpayrollallowances(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    installpayrollwages(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/fpinstaller/installpayrollwages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processInstallpayrollwages(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processInstallpayrollwages(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processInstallpayrollwages(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getPayrollData(): Observable<string[][]> {
        let url_ = this.baseUrl + "/api/v1/fpinstaller/payrolldata";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPayrollData(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPayrollData(<any>r));
                } catch (e) {
                    return <Observable<string[][]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[][]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayrollData(response: HttpResponseBase): Observable<string[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[][]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[][]>(<any>null);
    }

    /**
     * @return Success
     */
    getFPOrganizations(): Observable<FpOrganizationResource[]> {
        let url_ = this.baseUrl + "/api/v1/fpinstaller/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetFPOrganizations(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetFPOrganizations(<any>r));
                } catch (e) {
                    return <Observable<FpOrganizationResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FpOrganizationResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFPOrganizations(response: HttpResponseBase): Observable<FpOrganizationResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FpOrganizationResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FpOrganizationResource[]>(<any>null);
    }

    /**
     * @return Success
     */
    getInstallerTracking(): Observable<InstallerTrackingResource[]> {
        let url_ = this.baseUrl + "/api/v1/fpinstaller/tracking";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetInstallerTracking(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetInstallerTracking(<any>r));
                } catch (e) {
                    return <Observable<InstallerTrackingResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InstallerTrackingResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInstallerTracking(response: HttpResponseBase): Observable<InstallerTrackingResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InstallerTrackingResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InstallerTrackingResource[]>(<any>null);
    }

    /**
     * @return Success
     */
    deleteReportingGroup(groupKey: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/gl-group/{groupKey}";
        if (groupKey === undefined || groupKey === null)
            throw new Error("The parameter 'groupKey' must be defined.");
        url_ = url_.replace("{groupKey}", encodeURIComponent("" + groupKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteReportingGroup(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteReportingGroup(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteReportingGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param groupKey (optional) 
     * @param orgCode (optional) 
     * @param propertyCode (optional) 
     * @return Success
     */
    deleteReportingGroupMember(groupKey: string | undefined, orgCode: string | undefined, propertyCode: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/gl-group-member?";
        if (groupKey === null)
            throw new Error("The parameter 'groupKey' cannot be null.");
        else if (groupKey !== undefined)
            url_ += "GroupKey=" + encodeURIComponent("" + groupKey) + "&";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "OrgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (propertyCode === null)
            throw new Error("The parameter 'propertyCode' cannot be null.");
        else if (propertyCode !== undefined)
            url_ += "PropertyCode=" + encodeURIComponent("" + propertyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteReportingGroupMember(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteReportingGroupMember(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteReportingGroupMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getReportingGroups(): Observable<GLReportingGroup[]> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/get-gl-reporting-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetReportingGroups(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetReportingGroups(<any>r));
                } catch (e) {
                    return <Observable<GLReportingGroup[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GLReportingGroup[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportingGroups(response: HttpResponseBase): Observable<GLReportingGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GLReportingGroup[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GLReportingGroup[]>(<any>null);
    }

    /**
     * @return Success
     */
    getReportingGroupMembers(): Observable<GLReportingGroupMember[]> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/get-gl-reporting-group-members";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetReportingGroupMembers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetReportingGroupMembers(<any>r));
                } catch (e) {
                    return <Observable<GLReportingGroupMember[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GLReportingGroupMember[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportingGroupMembers(response: HttpResponseBase): Observable<GLReportingGroupMember[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GLReportingGroupMember[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GLReportingGroupMember[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postReportingGroup(body: GLReportingGroup | undefined): Observable<GLReportingGroup> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/gl-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostReportingGroup(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostReportingGroup(<any>r));
                } catch (e) {
                    return <Observable<GLReportingGroup>><any>_observableThrow(e);
                }
            } else
                return <Observable<GLReportingGroup>><any>_observableThrow(response_);
        }));
    }

    protected processPostReportingGroup(response: HttpResponseBase): Observable<GLReportingGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GLReportingGroup>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GLReportingGroup>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postReportingGroupMember(body: GLReportingGroupMember | undefined): Observable<GLReportingGroupMember> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/add-gl-group-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostReportingGroupMember(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostReportingGroupMember(<any>r));
                } catch (e) {
                    return <Observable<GLReportingGroupMember>><any>_observableThrow(e);
                }
            } else
                return <Observable<GLReportingGroupMember>><any>_observableThrow(response_);
        }));
    }

    protected processPostReportingGroupMember(response: HttpResponseBase): Observable<GLReportingGroupMember> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GLReportingGroupMember>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GLReportingGroupMember>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patchReportingGroupMembers(body: GroupKeyMemberResourceWithOriginals[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/update-gl-group-members";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPatchReportingGroupMembers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPatchReportingGroupMembers(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPatchReportingGroupMembers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cloneReportingGroup(body: CloneReportingGroupKeyResource | undefined): Observable<GLReportingGroup> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/clone-gl-report-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCloneReportingGroup(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCloneReportingGroup(<any>r));
                } catch (e) {
                    return <Observable<GLReportingGroup>><any>_observableThrow(e);
                }
            } else
                return <Observable<GLReportingGroup>><any>_observableThrow(response_);
        }));
    }

    protected processCloneReportingGroup(response: HttpResponseBase): Observable<GLReportingGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GLReportingGroup>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GLReportingGroup>(<any>null);
    }

    /**
     * @return Success
     */
    processFpReportingTables(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/fp-lists/process-fp-reporting-tables";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processProcessFpReportingTables(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processProcessFpReportingTables(<any>r));
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processProcessFpReportingTables(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Gets all Ledgers
     * @return Success
     */
    getLedgers(): Observable<LedgerSummary[]> {
        let url_ = this.baseUrl + "/api/v1/ledgers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetLedgers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetLedgers(<any>r));
                } catch (e) {
                    return <Observable<LedgerSummary[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerSummary[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLedgers(response: HttpResponseBase): Observable<LedgerSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerSummary[]>(<any>null);
    }

    /**
     * Gets Ledger with account info
     * @return Success
     */
    getLedgerById(ledgerId: number): Observable<LedgerDetail> {
        let url_ = this.baseUrl + "/api/v1/ledgers/{ledgerId}";
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetLedgerById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetLedgerById(<any>r));
                } catch (e) {
                    return <Observable<LedgerDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerDetail>><any>_observableThrow(response_);
        }));
    }

    protected processGetLedgerById(response: HttpResponseBase): Observable<LedgerDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerDetail>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDetail>(<any>null);
    }

    /**
     * @return Success
     */
    getAccountSplits(): Observable<AccountSplitResource[]> {
        let url_ = this.baseUrl + "/api/v1/managementFeeSplits/get-account-splits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAccountSplits(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAccountSplits(<any>r));
                } catch (e) {
                    return <Observable<AccountSplitResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountSplitResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountSplits(response: HttpResponseBase): Observable<AccountSplitResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSplitResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountSplitResource[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putAccountSplit(body: AccountSplitResource | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/managementFeeSplits/put-account-split";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutAccountSplit(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutAccountSplit(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutAccountSplit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAccountSplit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/managementFeeSplits/delete-account-split?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteAccountSplit(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteAccountSplit(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAccountSplit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getManagementFeeAccountSplits(): Observable<ManagementFeesAccountSplitsResource[]> {
        let url_ = this.baseUrl + "/api/v1/managementFeeSplits/get-management-fee-account-splits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetManagementFeeAccountSplits(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetManagementFeeAccountSplits(<any>r));
                } catch (e) {
                    return <Observable<ManagementFeesAccountSplitsResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ManagementFeesAccountSplitsResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetManagementFeeAccountSplits(response: HttpResponseBase): Observable<ManagementFeesAccountSplitsResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ManagementFeesAccountSplitsResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManagementFeesAccountSplitsResource[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putManagementFeeAccountSplit(body: ManagementFeesAccountSplitsResource | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/managementFeeSplits/put-management-fee-account-split";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutManagementFeeAccountSplit(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutManagementFeeAccountSplit(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutManagementFeeAccountSplit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteManagementFeeAccountSplit(orgCode: string, accountSplitId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/managementFeeSplits/delete-management-fee-account-split/{orgCode}/{accountSplitId}";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined.");
        url_ = url_.replace("{orgCode}", encodeURIComponent("" + orgCode));
        if (accountSplitId === undefined || accountSplitId === null)
            throw new Error("The parameter 'accountSplitId' must be defined.");
        url_ = url_.replace("{accountSplitId}", encodeURIComponent("" + accountSplitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteManagementFeeAccountSplit(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteManagementFeeAccountSplit(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteManagementFeeAccountSplit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets all organizations
     * @return Success
     */
    getOrganizations(): Observable<Organization[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrganizations(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrganizations(<any>r));
                } catch (e) {
                    return <Observable<Organization[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Organization[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizations(response: HttpResponseBase): Observable<Organization[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Organization[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Organization[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putOrganization(body: FpOrganizationResource | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/organiztions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutOrganization(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutOrganization(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutOrganization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets an organization - should really return 404 if not found.  Is this really used at all?
     * @return Success
     */
    getOrganizationById(orgId: number): Observable<Organization> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrganizationById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrganizationById(<any>r));
                } catch (e) {
                    return <Observable<Organization>><any>_observableThrow(e);
                }
            } else
                return <Observable<Organization>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationById(response: HttpResponseBase): Observable<Organization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Organization>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Organization>(<any>null);
    }

    /**
     * Gets an organization's ledger
     * @param snapshotId (optional) 
     * @param viewLedgerId (optional) 
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @return Success
     */
    getLedgerDetail(orgId: number, ledgerId: number, snapshotId: number | undefined, viewLedgerId: number | undefined, minDate: Date | undefined, maxDate: Date | undefined): Observable<UserLedgerDetail> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (snapshotId === null)
            throw new Error("The parameter 'snapshotId' cannot be null.");
        else if (snapshotId !== undefined)
            url_ += "snapshotId=" + encodeURIComponent("" + snapshotId) + "&";
        if (viewLedgerId === null)
            throw new Error("The parameter 'viewLedgerId' cannot be null.");
        else if (viewLedgerId !== undefined)
            url_ += "viewLedgerId=" + encodeURIComponent("" + viewLedgerId) + "&";
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toJSON() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetLedgerDetail(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetLedgerDetail(<any>r));
                } catch (e) {
                    return <Observable<UserLedgerDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserLedgerDetail>><any>_observableThrow(response_);
        }));
    }

    protected processGetLedgerDetail(response: HttpResponseBase): Observable<UserLedgerDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserLedgerDetail>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLedgerDetail>(<any>null);
    }

    /**
     * Gets a specifc ledger entry by id
     * @return Success
     */
    getLedgerEntry(orgId: number, ledgerId: number, entryId: number): Observable<LedgerEntry> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/entries/{entryId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (entryId === undefined || entryId === null)
            throw new Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetLedgerEntry(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetLedgerEntry(<any>r));
                } catch (e) {
                    return <Observable<LedgerEntry>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerEntry>><any>_observableThrow(response_);
        }));
    }

    protected processGetLedgerEntry(response: HttpResponseBase): Observable<LedgerEntry> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerEntry>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerEntry>(<any>null);
    }

    /**
     * Gets message queue items by status
     * @return Success
     */
    getOrgNotifications(orgId: number): Observable<WorkflowNotificationSummary[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/notifications";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrgNotifications(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrgNotifications(<any>r));
                } catch (e) {
                    return <Observable<WorkflowNotificationSummary[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowNotificationSummary[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrgNotifications(response: HttpResponseBase): Observable<WorkflowNotificationSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WorkflowNotificationSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowNotificationSummary[]>(<any>null);
    }

    /**
     * Adds a Ledger entry
     * @param orgId The org to update
     * @param ledgerId The ledger to update
     * @param viewId The view - necessary to check security access
     * @param body (optional) The Entry to add
     * @return Success
     */
    addLedgerEntry(orgId: number, ledgerId: number, viewId: number, body: LedgerEntry | undefined): Observable<LedgerEntry> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/views/{viewId}/entries";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processAddLedgerEntry(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddLedgerEntry(<any>r));
                } catch (e) {
                    return <Observable<LedgerEntry>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerEntry>><any>_observableThrow(response_);
        }));
    }

    protected processAddLedgerEntry(response: HttpResponseBase): Observable<LedgerEntry> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <LedgerEntry>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerEntry>(<any>null);
    }

    /**
     * Adds a batch of Ledger entries only applicable if user is super user
     * @param orgId The org to update
     * @param ledgerId The ledger to update
     * @param body (optional) The Entries to add
     * @return Success
     */
    addLedgerEntriesSuperUser(orgId: number, ledgerId: number, body: LedgerEntry[] | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/entrybatches";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processAddLedgerEntriesSuperUser(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddLedgerEntriesSuperUser(<any>r));
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processAddLedgerEntriesSuperUser(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Adds a batch of Ledger entries verifying the user has access to view
     * @param orgId The org to update
     * @param ledgerId The ledger to update
     * @param viewId The view - necessary to check security access
     * @param body (optional) The Entries to add
     * @return Success
     */
    addLedgerEntries(orgId: number, ledgerId: number, viewId: number, body: LedgerEntry[] | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/views/{viewId}/entrybatches";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processAddLedgerEntries(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddLedgerEntries(<any>r));
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processAddLedgerEntries(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Gets all account entries for a given org/ledger/account
     * @return Success
     */
    getAccountEntries(orgId: number, ledgerId: number, accountCode: string): Observable<LedgerEntry[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/accounts/{accountCode}/entries";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (accountCode === undefined || accountCode === null)
            throw new Error("The parameter 'accountCode' must be defined.");
        url_ = url_.replace("{accountCode}", encodeURIComponent("" + accountCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAccountEntries(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAccountEntries(<any>r));
                } catch (e) {
                    return <Observable<LedgerEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountEntries(response: HttpResponseBase): Observable<LedgerEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerEntry[]>(<any>null);
    }

    /**
     * Gets the latest account entries for a given org/ledger/account
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @return Success
     */
    getCurrentAccountEntries(orgId: number, ledgerId: number, accountCode: string, minDate: Date | undefined, maxDate: Date | undefined): Observable<LedgerEntry[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/accounts/{accountCode}/currententries?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (accountCode === undefined || accountCode === null)
            throw new Error("The parameter 'accountCode' must be defined.");
        url_ = url_.replace("{accountCode}", encodeURIComponent("" + accountCode));
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toJSON() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCurrentAccountEntries(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCurrentAccountEntries(<any>r));
                } catch (e) {
                    return <Observable<LedgerEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentAccountEntries(response: HttpResponseBase): Observable<LedgerEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerEntry[]>(<any>null);
    }

    /**
     * Gets an organization's ledger
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @return Success
     */
    getCalculatedLedgerEntries(orgId: number, ledgerId: number, accountCode: string, minDate: Date | undefined, maxDate: Date | undefined): Observable<LedgerEntry[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/accounts/{accountCode}/calculatedEntries?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (accountCode === undefined || accountCode === null)
            throw new Error("The parameter 'accountCode' must be defined.");
        url_ = url_.replace("{accountCode}", encodeURIComponent("" + accountCode));
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toJSON() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCalculatedLedgerEntries(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCalculatedLedgerEntries(<any>r));
                } catch (e) {
                    return <Observable<LedgerEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalculatedLedgerEntries(response: HttpResponseBase): Observable<LedgerEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerEntry[]>(<any>null);
    }

    /**
     * Gets an organization's ledger
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @return Success
     */
    getCalculatedViewEntries(orgId: number, ledgerId: number, viewLedgerId: number, accountCode: string, minDate: Date | undefined, maxDate: Date | undefined): Observable<LedgerEntry[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/views/{viewLedgerId}/accounts/{accountCode}/calculatedEntries?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (viewLedgerId === undefined || viewLedgerId === null)
            throw new Error("The parameter 'viewLedgerId' must be defined.");
        url_ = url_.replace("{viewLedgerId}", encodeURIComponent("" + viewLedgerId));
        if (accountCode === undefined || accountCode === null)
            throw new Error("The parameter 'accountCode' must be defined.");
        url_ = url_.replace("{accountCode}", encodeURIComponent("" + accountCode));
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toJSON() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCalculatedViewEntries(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCalculatedViewEntries(<any>r));
                } catch (e) {
                    return <Observable<LedgerEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalculatedViewEntries(response: HttpResponseBase): Observable<LedgerEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerEntry[]>(<any>null);
    }

    /**
     * Gets all snapshots for an organization's ledger
     * @return Success
     */
    getSnapshots(orgId: number, ledgerId: number): Observable<Snapshot[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/snapshots";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSnapshots(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSnapshots(<any>r));
                } catch (e) {
                    return <Observable<Snapshot[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Snapshot[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSnapshots(response: HttpResponseBase): Observable<Snapshot[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Snapshot[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Snapshot[]>(<any>null);
    }

    /**
     * Saves a new Snapshot
     * @param body (optional) 
     * @return Success
     */
    postSnaphshot(orgId: number, ledgerId: number, body: Snapshot | undefined): Observable<Snapshot> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/snapshots";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostSnaphshot(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostSnaphshot(<any>r));
                } catch (e) {
                    return <Observable<Snapshot>><any>_observableThrow(e);
                }
            } else
                return <Observable<Snapshot>><any>_observableThrow(response_);
        }));
    }

    protected processPostSnaphshot(response: HttpResponseBase): Observable<Snapshot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Snapshot>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Snapshot>(<any>null);
    }

    /**
     * Gets all snapshots for an organization's ledger that include the view
     * @return Success
     */
    getViewSnapshots(orgId: number, ledgerId: number, viewId: number): Observable<Snapshot[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/views/{viewId}/snapshots";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetViewSnapshots(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetViewSnapshots(<any>r));
                } catch (e) {
                    return <Observable<Snapshot[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Snapshot[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetViewSnapshots(response: HttpResponseBase): Observable<Snapshot[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Snapshot[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Snapshot[]>(<any>null);
    }

    /**
     * Gets a  Snapshot
     * @return Success
     */
    getSnapshot(orgId: number, ledgerId: number, snapshotId: number): Observable<Snapshot> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/snapshots/{snapshotId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (snapshotId === undefined || snapshotId === null)
            throw new Error("The parameter 'snapshotId' must be defined.");
        url_ = url_.replace("{snapshotId}", encodeURIComponent("" + snapshotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSnapshot(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSnapshot(<any>r));
                } catch (e) {
                    return <Observable<Snapshot>><any>_observableThrow(e);
                }
            } else
                return <Observable<Snapshot>><any>_observableThrow(response_);
        }));
    }

    protected processGetSnapshot(response: HttpResponseBase): Observable<Snapshot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Snapshot>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Snapshot>(<any>null);
    }

    /**
     * @return Success
     */
    getComments(orgId: number, ledgerId: number): Observable<LedgerComment[]> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/comments";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetComments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetComments(<any>r));
                } catch (e) {
                    return <Observable<LedgerComment[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerComment[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<LedgerComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerComment[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerComment[]>(<any>null);
    }

    /**
     * Saves a new Comment
     * @param body (optional) 
     * @return Success
     */
    postComment(orgId: number, ledgerId: number, body: LedgerComment | undefined): Observable<LedgerComment> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/comments";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostComment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostComment(<any>r));
                } catch (e) {
                    return <Observable<LedgerComment>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerComment>><any>_observableThrow(response_);
        }));
    }

    protected processPostComment(response: HttpResponseBase): Observable<LedgerComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <LedgerComment>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerComment>(<any>null);
    }

    /**
     * @return Success
     */
    getComment(orgId: number, ledgerId: number, commentId: number): Observable<LedgerComment> {
        let url_ = this.baseUrl + "/api/v1/organiztions/{orgId}/ledgers/{ledgerId}/comments/{commentId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetComment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetComment(<any>r));
                } catch (e) {
                    return <Observable<LedgerComment>><any>_observableThrow(e);
                }
            } else
                return <Observable<LedgerComment>><any>_observableThrow(response_);
        }));
    }

    protected processGetComment(response: HttpResponseBase): Observable<LedgerComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LedgerComment>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerComment>(<any>null);
    }

    /**
     * @return Success
     */
    getOrgMappingLookups(): Observable<OrgMappingLookup[]> {
        let url_ = this.baseUrl + "/api/v1/orgMappingLookup/get-org-mapping-lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrgMappingLookups(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrgMappingLookups(<any>r));
                } catch (e) {
                    return <Observable<OrgMappingLookup[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrgMappingLookup[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrgMappingLookups(response: HttpResponseBase): Observable<OrgMappingLookup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrgMappingLookup[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgMappingLookup[]>(<any>null);
    }

    /**
     * @return Success
     */
    getOrgMappingLookup(id: number): Observable<OrgMappingLookup> {
        let url_ = this.baseUrl + "/api/v1/orgMappingLookup/get-org-mapping-lookup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrgMappingLookup(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrgMappingLookup(<any>r));
                } catch (e) {
                    return <Observable<OrgMappingLookup>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrgMappingLookup>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrgMappingLookup(response: HttpResponseBase): Observable<OrgMappingLookup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrgMappingLookup>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgMappingLookup>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putOrgMappingLookup(body: OrgMappingLookup | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/orgMappingLookup/put-org-mapping-lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutOrgMappingLookup(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutOrgMappingLookup(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutOrgMappingLookup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteOrgMappingLookup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/orgMappingLookup/delete-org-mapping-lookup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOrgMappingLookup(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOrgMappingLookup(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrgMappingLookup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets all employees in a budget year
     * @return Success
     */
    getEmployees(orgId: number, budgetYear: number): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/budgets/{budgetYear}/employees";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (budgetYear === undefined || budgetYear === null)
            throw new Error("The parameter 'budgetYear' must be defined.");
        url_ = url_.replace("{budgetYear}", encodeURIComponent("" + budgetYear));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEmployees(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEmployees(<any>r));
                } catch (e) {
                    return <Observable<Employee[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployees(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Employee[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee[]>(<any>null);
    }

    /**
     * Gets an employee
     * @return Success
     */
    getEmployee(orgId: number, empId: number): Observable<Employee> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/employees/{empId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEmployee(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEmployee(<any>r));
                } catch (e) {
                    return <Observable<Employee>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployee(response: HttpResponseBase): Observable<Employee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Employee>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee>(<any>null);
    }

    /**
     * Deletes an employee
     * @return Success
     */
    deleteEmployee(orgId: number, empId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/employees/{empId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteEmployee(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteEmployee(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Upserts an employee
     * @param body (optional) 
     * @return Success
     */
    postEmployee(orgId: number, body: Employee | undefined): Observable<Employee> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/employees";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostEmployee(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostEmployee(<any>r));
                } catch (e) {
                    return <Observable<Employee>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee>><any>_observableThrow(response_);
        }));
    }

    protected processPostEmployee(response: HttpResponseBase): Observable<Employee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Employee>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee>(<any>null);
    }

    /**
     * @return Success
     */
    getPayItem(orgId: number, empId: number, payItemId: number): Observable<PayItem> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/employees/{empId}/payItems/{payItemId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        if (payItemId === undefined || payItemId === null)
            throw new Error("The parameter 'payItemId' must be defined.");
        url_ = url_.replace("{payItemId}", encodeURIComponent("" + payItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPayItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPayItem(<any>r));
                } catch (e) {
                    return <Observable<PayItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayItem>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayItem(response: HttpResponseBase): Observable<PayItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PayItem>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayItem>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postPayItem(orgId: number, empId: number, body: PayItem | undefined): Observable<PayItem> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/employees/{empId}/payItems";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostPayItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostPayItem(<any>r));
                } catch (e) {
                    return <Observable<PayItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayItem>><any>_observableThrow(response_);
        }));
    }

    protected processPostPayItem(response: HttpResponseBase): Observable<PayItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <PayItem>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayItem>(<any>null);
    }

    /**
     * @return Success
     */
    getHourAllocation(orgId: number, empId: number, hourAllocationId: number): Observable<HourAllocation> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/employees/{empId}/hourAllocations/{hourAllocationId}";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        if (hourAllocationId === undefined || hourAllocationId === null)
            throw new Error("The parameter 'hourAllocationId' must be defined.");
        url_ = url_.replace("{hourAllocationId}", encodeURIComponent("" + hourAllocationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetHourAllocation(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetHourAllocation(<any>r));
                } catch (e) {
                    return <Observable<HourAllocation>><any>_observableThrow(e);
                }
            } else
                return <Observable<HourAllocation>><any>_observableThrow(response_);
        }));
    }

    protected processGetHourAllocation(response: HttpResponseBase): Observable<HourAllocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <HourAllocation>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HourAllocation>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postHourAllocation(orgId: number, empId: number, body: HourAllocation | undefined): Observable<HourAllocation> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/employees/{empId}/hourAllocations";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostHourAllocation(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostHourAllocation(<any>r));
                } catch (e) {
                    return <Observable<HourAllocation>><any>_observableThrow(e);
                }
            } else
                return <Observable<HourAllocation>><any>_observableThrow(response_);
        }));
    }

    protected processPostHourAllocation(response: HttpResponseBase): Observable<HourAllocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <HourAllocation>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HourAllocation>(<any>null);
    }

    /**
     * Gets all the positions
     * @return Success
     */
    getPositions(): Observable<PositionType[]> {
        let url_ = this.baseUrl + "/api/v1/positions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPositions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPositions(<any>r));
                } catch (e) {
                    return <Observable<PositionType[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PositionType[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPositions(response: HttpResponseBase): Observable<PositionType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PositionType[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PositionType[]>(<any>null);
    }

    /**
     * Gets all the positions
     * @return Success
     */
    getPayTypes(): Observable<PayType[]> {
        let url_ = this.baseUrl + "/api/v1/payTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPayTypes(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPayTypes(<any>r));
                } catch (e) {
                    return <Observable<PayType[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayType[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayTypes(response: HttpResponseBase): Observable<PayType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PayType[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayType[]>(<any>null);
    }

    /**
     * Gets all the positions
     * @return Success
     */
    getPositionTypes(): Observable<PositionTypeResource[]> {
        let url_ = this.baseUrl + "/position-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPositionTypes(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPositionTypes(<any>r));
                } catch (e) {
                    return <Observable<PositionTypeResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PositionTypeResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPositionTypes(response: HttpResponseBase): Observable<PositionTypeResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PositionTypeResource[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PositionTypeResource[]>(<any>null);
    }

    /**
     * Gets a the position type
     * @return Success
     */
    getPositionType(positionTypeId: number): Observable<PositionTypeResource> {
        let url_ = this.baseUrl + "/get-position-type/{positionTypeId}";
        if (positionTypeId === undefined || positionTypeId === null)
            throw new Error("The parameter 'positionTypeId' must be defined.");
        url_ = url_.replace("{positionTypeId}", encodeURIComponent("" + positionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPositionType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPositionType(<any>r));
                } catch (e) {
                    return <Observable<PositionTypeResource>><any>_observableThrow(e);
                }
            } else
                return <Observable<PositionTypeResource>><any>_observableThrow(response_);
        }));
    }

    protected processGetPositionType(response: HttpResponseBase): Observable<PositionTypeResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PositionTypeResource>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PositionTypeResource>(<any>null);
    }

    /**
     * Delete a position type
     * @return Success
     */
    deletePositionType(positionTypeId: number): Observable<void> {
        let url_ = this.baseUrl + "/delete-position-type/{positionTypeId}";
        if (positionTypeId === undefined || positionTypeId === null)
            throw new Error("The parameter 'positionTypeId' must be defined.");
        url_ = url_.replace("{positionTypeId}", encodeURIComponent("" + positionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeletePositionType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeletePositionType(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePositionType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Puts a position type
     * @param body (optional) 
     * @return Success
     */
    putPositionType(body: PositionTypeResource | undefined): Observable<void> {
        let url_ = this.baseUrl + "/put-position-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPositionType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPositionType(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutPositionType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Adds a budget export.
     * @param body (optional) Couldn't call this export because caused keyword conflict when client was generated.
     * @return Success
     */
    exportBudget(body: Export | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/processes/ExportBudget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processExportBudget(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processExportBudget(<any>r));
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processExportBudget(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Gets exprt queue items by status
     * @param status (optional) 
     * @param createdOnMin (optional) 
     * @param createdOnMax (optional) 
     * @return Success
     */
    getExportQueue(status: QueueItemStatus | undefined, createdOnMin: Date | undefined, createdOnMax: Date | undefined): Observable<ExportQueueItemWithPayload[]> {
        let url_ = this.baseUrl + "/api/v1/queues/exports?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (createdOnMin === null)
            throw new Error("The parameter 'createdOnMin' cannot be null.");
        else if (createdOnMin !== undefined)
            url_ += "createdOnMin=" + encodeURIComponent(createdOnMin ? "" + createdOnMin.toJSON() : "") + "&";
        if (createdOnMax === null)
            throw new Error("The parameter 'createdOnMax' cannot be null.");
        else if (createdOnMax !== undefined)
            url_ += "createdOnMax=" + encodeURIComponent(createdOnMax ? "" + createdOnMax.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetExportQueue(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetExportQueue(<any>r));
                } catch (e) {
                    return <Observable<ExportQueueItemWithPayload[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportQueueItemWithPayload[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExportQueue(response: HttpResponseBase): Observable<ExportQueueItemWithPayload[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExportQueueItemWithPayload[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportQueueItemWithPayload[]>(<any>null);
    }

    /**
     * Gets message queue items by status
     * @param status (optional) 
     * @param createdOnMin (optional) 
     * @param createdOnMax (optional) 
     * @return Success
     */
    getMessageQueue(status: QueueItemStatus | undefined, createdOnMin: Date | undefined, createdOnMax: Date | undefined): Observable<MessageQueueItemWithPayload[]> {
        let url_ = this.baseUrl + "/api/v1/queues/messages?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (createdOnMin === null)
            throw new Error("The parameter 'createdOnMin' cannot be null.");
        else if (createdOnMin !== undefined)
            url_ += "createdOnMin=" + encodeURIComponent(createdOnMin ? "" + createdOnMin.toJSON() : "") + "&";
        if (createdOnMax === null)
            throw new Error("The parameter 'createdOnMax' cannot be null.");
        else if (createdOnMax !== undefined)
            url_ += "createdOnMax=" + encodeURIComponent(createdOnMax ? "" + createdOnMax.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMessageQueue(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMessageQueue(<any>r));
                } catch (e) {
                    return <Observable<MessageQueueItemWithPayload[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageQueueItemWithPayload[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMessageQueue(response: HttpResponseBase): Observable<MessageQueueItemWithPayload[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MessageQueueItemWithPayload[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageQueueItemWithPayload[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSystemConfig(): Observable<SystemConfig> {
        let url_ = this.baseUrl + "/api/v1/system-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSystemConfig(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSystemConfig(<any>r));
                } catch (e) {
                    return <Observable<SystemConfig>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemConfig>><any>_observableThrow(response_);
        }));
    }

    protected processGetSystemConfig(response: HttpResponseBase): Observable<SystemConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SystemConfig>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemConfig>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSystemConfig(body: SystemConfig | undefined): Observable<SystemConfig> {
        let url_ = this.baseUrl + "/api/v1/update-system-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateSystemConfig(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateSystemConfig(<any>r));
                } catch (e) {
                    return <Observable<SystemConfig>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemConfig>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSystemConfig(response: HttpResponseBase): Observable<SystemConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SystemConfig>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemConfig>(<any>null);
    }

    /**
     * Gets all Users
     * @return Success
     */
    getUsers(): Observable<UserSummary[]> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUsers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUsers(<any>r));
                } catch (e) {
                    return <Observable<UserSummary[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserSummary[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSummary[]>(<any>null);
    }

    /**
     * Gets information about the current user
     * @param body (optional) 
     * @return Success
     */
    syncUser(body: MinimalUserInfo | undefined): Observable<UserSummary> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSyncUser(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSyncUser(<any>r));
                } catch (e) {
                    return <Observable<UserSummary>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserSummary>><any>_observableThrow(response_);
        }));
    }

    protected processSyncUser(response: HttpResponseBase): Observable<UserSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <UserSummary>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSummary>(<any>null);
    }

    /**
     * Gets all Users With User Access
     * @return Success
     */
    getAllUsersWithDetails(): Observable<UserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/userswithdetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllUsersWithDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllUsersWithDetails(<any>r));
                } catch (e) {
                    return <Observable<UserDetail[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDetail[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUsersWithDetails(response: HttpResponseBase): Observable<UserDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDetail[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetail[]>(<any>null);
    }

    /**
     * Gets information about the current user
     * @return Success
     */
    getCurrentUser(): Observable<UserStateInfo> {
        let url_ = this.baseUrl + "/api/v1/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCurrentUser(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCurrentUser(<any>r));
                } catch (e) {
                    return <Observable<UserStateInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserStateInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserStateInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserStateInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserStateInfo>(<any>null);
    }

    /**
     * Gets information about the current user
     * @return Success
     */
    getUserDetail(userId: number): Observable<UserDetail> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserDetail(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserDetail(<any>r));
                } catch (e) {
                    return <Observable<UserDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDetail>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDetail(response: HttpResponseBase): Observable<UserDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDetail>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetail>(<any>null);
    }

    /**
     * Gets information about the current user
     * @param body (optional) 
     * @return Success
     */
    updateAccessMatrix(userId: number, body: AccessMatrix | undefined): Observable<AccessMatrix> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accessmatrix";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateAccessMatrix(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateAccessMatrix(<any>r));
                } catch (e) {
                    return <Observable<AccessMatrix>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccessMatrix>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAccessMatrix(response: HttpResponseBase): Observable<AccessMatrix> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <AccessMatrix>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccessMatrix>(<any>null);
    }

    /**
     * Gets all roles
     * @return Success
     */
    getRoles(): Observable<Role[]> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRoles(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRoles(<any>r));
                } catch (e) {
                    return <Observable<Role[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Role[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<Role[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Role[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Role[]>(<any>null);
    }

    /**
     * Send out email to admin/Rebecca concerning role/organization access form requests
     * @param body (optional) 
     * @return Success
     */
    requestRoleAccess(userId: number, body: RequestAccessForm | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/requestroleaccess";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processRequestRoleAccess(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRequestRoleAccess(<any>r));
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processRequestRoleAccess(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Gets views information
     * @return Success
     */
    getViews(): Observable<ViewSummary[]> {
        let url_ = this.baseUrl + "/api/v1/glviews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetViews(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetViews(<any>r));
                } catch (e) {
                    return <Observable<ViewSummary[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewSummary[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetViews(response: HttpResponseBase): Observable<ViewSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ViewSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewSummary[]>(<any>null);
    }

    /**
     * Gets view by id
     * @return Success
     */
    getViewById(viewId: number): Observable<ViewSummary> {
        let url_ = this.baseUrl + "/api/v1/glviews/{viewId}";
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetViewById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetViewById(<any>r));
                } catch (e) {
                    return <Observable<ViewSummary>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewSummary>><any>_observableThrow(response_);
        }));
    }

    protected processGetViewById(response: HttpResponseBase): Observable<ViewSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ViewSummary>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewSummary>(<any>null);
    }

    /**
     * Associates a view with workflow ids
     * @param body (optional) 
     * @return Success
     */
    postViewWorkflowIds(viewId: number, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/glviews/{viewId}/workflowIds";
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostViewWorkflowIds(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostViewWorkflowIds(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPostViewWorkflowIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Deletes a workflow by id
     * @return Success
     */
    deleteWorkflowById(workflowId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/workflows/{workflowId}";
        if (workflowId === undefined || workflowId === null)
            throw new Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteWorkflowById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteWorkflowById(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteWorkflowById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets all workflows
     * @return Success
     */
    getWorkflows(): Observable<Workflow[]> {
        let url_ = this.baseUrl + "/api/v1/workflows";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetWorkflows(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetWorkflows(<any>r));
                } catch (e) {
                    return <Observable<Workflow[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Workflow[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkflows(response: HttpResponseBase): Observable<Workflow[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Workflow[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Workflow[]>(<any>null);
    }

    /**
     * Deletes a workflow by id
     * @param body (optional) 
     * @return Success
     */
    upsertWorkflow(body: WorkflowSummary | undefined): Observable<WorkflowSummary> {
        let url_ = this.baseUrl + "/api/v1/workflows";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpsertWorkflow(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpsertWorkflow(<any>r));
                } catch (e) {
                    return <Observable<WorkflowSummary>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowSummary>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertWorkflow(response: HttpResponseBase): Observable<WorkflowSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <WorkflowSummary>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowSummary>(<any>null);
    }

    /**
     * Gets the current actions available to the current user for a given orgId, viewId.
     * @return Success
     */
    getCurrentUserActions(orgId: number, viewId: number): Observable<WorkflowAction[]> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/views/{viewId}/useractions";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCurrentUserActions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCurrentUserActions(<any>r));
                } catch (e) {
                    return <Observable<WorkflowAction[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowAction[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUserActions(response: HttpResponseBase): Observable<WorkflowAction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WorkflowAction[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowAction[]>(<any>null);
    }

    /**
     * @return Success
     */
    getOrgViewWorkflowStates(orgId: number, viewId: number): Observable<WorkflowStateHistory[]> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/views/{viewId}/workflowStates";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrgViewWorkflowStates(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrgViewWorkflowStates(<any>r));
                } catch (e) {
                    return <Observable<WorkflowStateHistory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowStateHistory[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrgViewWorkflowStates(response: HttpResponseBase): Observable<WorkflowStateHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WorkflowStateHistory[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowStateHistory[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWorkflowStates(): Observable<WorkflowState[]> {
        let url_ = this.baseUrl + "/api/v1/workflows/currentStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetWorkflowStates(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetWorkflowStates(<any>r));
                } catch (e) {
                    return <Observable<WorkflowState[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowState[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkflowStates(response: HttpResponseBase): Observable<WorkflowState[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WorkflowState[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowState[]>(<any>null);
    }

    /**
     * Reopens a Workflow
     * @param body (optional) 
     * @return Success
     */
    reopenWorkflow(orgId: number, ledgerId: number, viewId: number, body: ReopenRequest | undefined): Observable<WorkflowState> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/ledgers/{ledgerId}/views/{viewId}/workflowReopens";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processReopenWorkflow(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processReopenWorkflow(<any>r));
                } catch (e) {
                    return <Observable<WorkflowState>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowState>><any>_observableThrow(response_);
        }));
    }

    protected processReopenWorkflow(response: HttpResponseBase): Observable<WorkflowState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <WorkflowState>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowState>(<any>null);
    }

    /**
     * Gets the current actions available to the current user for a given orgId, viewId.
     * @param body (optional) 
     * @return Success
     */
    addWorkflowEvent(orgId: number, ledgerId: number, viewId: number, body: WorkflowEvent | undefined): Observable<WorkflowStateHistory[]> {
        let url_ = this.baseUrl + "/api/v1/organizations/{orgId}/ledgers/{ledgerId}/views/{viewId}/workflowEvents";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (ledgerId === undefined || ledgerId === null)
            throw new Error("The parameter 'ledgerId' must be defined.");
        url_ = url_.replace("{ledgerId}", encodeURIComponent("" + ledgerId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processAddWorkflowEvent(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddWorkflowEvent(<any>r));
                } catch (e) {
                    return <Observable<WorkflowStateHistory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowStateHistory[]>><any>_observableThrow(response_);
        }));
    }

    protected processAddWorkflowEvent(response: HttpResponseBase): Observable<WorkflowStateHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <WorkflowStateHistory[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowStateHistory[]>(<any>null);
    }

    /**
     * Deletes a workflows step, returning NoContent on Success or NotFound if the resource with matching id doesn't exist.
     * @return Success
     */
    deleteWorkflowStep(stepId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/workflowSteps/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteWorkflowStep(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteWorkflowStep(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteWorkflowStep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets a workflow step by id
     * @return Success
     */
    getWorkflowStepById(stepId: number): Observable<WorkflowStep> {
        let url_ = this.baseUrl + "/api/v1/workflowSteps/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetWorkflowStepById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetWorkflowStepById(<any>r));
                } catch (e) {
                    return <Observable<WorkflowStep>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowStep>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkflowStepById(response: HttpResponseBase): Observable<WorkflowStep> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WorkflowStep>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowStep>(<any>null);
    }

    /**
     * Gets all workflow steps
     * @return Success
     */
    getWorkflowSteps(): Observable<WorkflowStep[]> {
        let url_ = this.baseUrl + "/api/v1/workflowSteps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetWorkflowSteps(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetWorkflowSteps(<any>r));
                } catch (e) {
                    return <Observable<WorkflowStep[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowStep[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkflowSteps(response: HttpResponseBase): Observable<WorkflowStep[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WorkflowStep[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowStep[]>(<any>null);
    }

    /**
     * Upserts a workflow step
     * @param body (optional) 
     * @return Success
     */
    postWorkflowStep(body: WorkflowStepUpsertInfo | undefined): Observable<WorkflowStep> {
        let url_ = this.baseUrl + "/api/v1/workflowSteps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processPostWorkflowStep(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostWorkflowStep(<any>r));
                } catch (e) {
                    return <Observable<WorkflowStep>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkflowStep>><any>_observableThrow(response_);
        }));
    }

    protected processPostWorkflowStep(response: HttpResponseBase): Observable<WorkflowStep> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <WorkflowStep>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkflowStep>(<any>null);
    }

    /**
     * Gets a workflow step help file
     * @return Success
     */
    getWorkflowStepHelpInfoById(stepId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/workflowSteps/{stepId}/HelpInfo";
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetWorkflowStepHelpInfoById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetWorkflowStepHelpInfoById(<any>r));
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkflowStepHelpInfoById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface AccessMatrix {
    items: AccessMatrixItem[];
}

export interface AccessMatrixItem {
    orgId: number;
    viewId: number;
    roleId: number;
}

export enum AccountingMethodType {
    All = "All",
    Accrual = "Accrual",
    Cash = "Cash",
}

export interface AccountSplitResource {
    id: number;
    name: string;
    type: string;
    orgCode: string;
    account: string;
    percentage: number;
}

export interface ApplicationViewsResource {
    id: number;
    key: string;
    view: string;
    accountCode: string;
    parentAccountCode: string;
    name: string;
    calculationExpression?: string | undefined;
    displayAccountCode?: string | undefined;
    isNegated?: boolean | undefined;
    sortIndex: number;
    isReadOnly?: boolean | undefined;
    isIgnoredInTotals?: boolean | undefined;
    customValidation?: string | undefined;
    isHidden?: boolean | undefined;
    deletedOn?: Date | undefined;
    deletedByUserId?: number | undefined;
    isChecked: boolean;
}

export interface CloneReportingGroupKeyResource {
    groupKey: string;
    name: string;
    originalGroupKey: string;
}

export interface Employee {
    empId: number;
    externalId?: string | undefined;
    budgetYear: number;
    isCurrentValuesLocked: boolean;
    isFullTime: boolean;
    name: string;
    position: string;
    payItems: PayItem[];
    hourAllocations: HourAllocation[];
}

export interface EmployeeExtended extends Employee {
    departmentCode: string;
}

export interface Estimate {
    appliedOn: Date;
    creatorId?: number | undefined;
    createdOn?: Date | undefined;
    estimateId: number;
    estimateType: EstimateType;
    value: number;
    sentToEntrataOn?: Date | undefined;
}

export interface EstimateAggregation {
    areaType: RevenueAreaType;
    estimateType: EstimateType;
    orgId: number;
    orgSelfRevAreaId: number;
    count: number;
    sum: number;
}

/** An Estimate with its parent revenueAreaId */
export interface RevenueAreaEstimate {
    appliedOn: Date;
    creatorId?: number | undefined;
    createdOn?: Date | undefined;
    estimateId: number;
    estimateType: EstimateType;
    value: number;
    sentToEntrataOn?: Date | undefined;
    /** The revenueAreaId this batch Item belongs to. */
    revAreaId: number;
}

/** An estimate with upsert behavior */
export interface EstimateBatchItem extends RevenueAreaEstimate {
    /** Controls how an item will be saved. */
    saveBehavior?: EstimateUpsertBehavior | undefined;
}

export enum EstimateType {
    OriginalAvgRate = "OriginalAvgRate",
    EstRenewalRate = "EstRenewalRate",
    EstNewRate = "EstNewRate",
    OriginalFpRate = "OriginalFpRate",
    EstRenewalLeases = "EstRenewalLeases",
    OriginalLeaseCount = "OriginalLeaseCount",
    UnitCount = "UnitCount",
    EstNewLeases = "EstNewLeases",
    TargetOccupancyPct = "TargetOccupancyPct",
    TargetRenewalPct = "TargetRenewalPct",
    TargetRateIncreasePct = "TargetRateIncreasePct",
    EstBaseFpRate = "EstBaseFpRate",
    Invalid = "Invalid",
}

export enum EstimateUpsertBehavior {
    BasedOnDtoId = "BasedOnDtoId",
    ReplaceInitial = "ReplaceInitial",
    ReplaceCurrent = "ReplaceCurrent",
    ForceInsert = "ForceInsert",
}

export interface Export {
    ledgerId: number;
    orgId: number;
    viewId: number;
}

export interface ExportQueueItemWithPayload {
    queueItemId: number;
    creatorId: number;
    createdOn: Date;
    queueItemType: QueueItemType;
    attempts: number;
    lastMessage?: string | undefined;
    startedOn?: Date | undefined;
    completedOn?: Date | undefined;
    payload: Export;
}

export interface FpOrganizationResource {
    orgId: number;
    orgCode: string;
    name: string;
    accountingMethodType: number;
    metaJson?: string | undefined;
    lagMonth: number;
    propertyTypeName: string;
    entrataPropertyId: string;
}

export interface GLReportingGroup {
    groupKey: string;
    name: string;
    glReportingGroupMember?: GLReportingGroupMember[] | undefined;
}

export interface GLReportingGroupMember {
    groupKey: string;
    orgCode: string;
    propertyCode: string;
    groupKeyNavigation?: GLReportingGroup | undefined;
}

export interface GroupKeyMemberResourceWithOriginals {
    groupKey: string;
    orgCode: string;
    propertyCode: string;
    originalOrgCode: string;
    originalPropertyCode: string;
}

export interface HourAllocation {
    hourAllocationId: number;
    month: number;
    hours: number;
}

export interface InsertPricingResource {
    amount: number;
    propertyId: number;
    revAreaEstimateId: number;
    unitCode: string;
}

export interface InsertPricingResult {
    revAreaEstimateId: number;
    status: string;
    isValid?: string | undefined;
    message?: string | undefined;
    referenceId?: number | undefined;
}

export interface InstallerTrackingResource {
    id: number;
    startDateTimeUtc: Date;
    endDateTime: Date;
    command: string;
    results: string;
    userId: number;
    userName: string;
}

export interface LeaseInfoMeta {
    approved?: Date | undefined;
    leaseCategory: string;
    leaseTerm: string;
    occupiedStart?: Date | undefined;
    occupiedEnd?: Date | undefined;
    updatedOn: Date;
}

export interface LedgerAccount {
    accountCode: string;
    accountingMethod: AccountingMethodType;
    name: string;
    displayAccountCode?: string | undefined;
    parentAccountCode?: string | undefined;
    sortIndex: number;
    calculationExpression?: string | undefined;
    validationExpression?: string | undefined;
    isIgnoredInTotals: boolean;
    isNegated: boolean;
    isHidden: boolean;
    isReadOnly: boolean;
}

export interface LedgerAccountNode extends LedgerAccount {
    parentAccountCode?: string | undefined;
    readonly parent?: LedgerAccountNode | undefined;
    readonly children: LedgerAccountNode[];
    readonly root?: LedgerAccountNode | undefined;
    readonly accountIndex: { [key: string]: LedgerAccountNode; };
}

export interface LedgerComment {
    commentId: number;
    accountCode: string;
    appliedOn?: Date | undefined;
    creatorId?: number | undefined;
    createdOn?: Date | undefined;
    comment: string;
    isHidden: boolean;
}

export interface LedgerConfiguration {
    additionalEditors?: LedgerConfigurationEditor[] | undefined;
}

export interface LedgerConfigurationEditor {
    id: string;
    allowedOrgsRegex: string;
}

export interface LedgerSummary {
    ledgerId: number;
    name: string;
    configuration: LedgerConfiguration;
}

export interface LedgerDetail extends LedgerSummary {
    accountTree: LedgerAccountNode;
    ledgerEntries: LedgerEntry[];
    ledgerComments: LedgerComment[];
}

export interface LedgerEntry {
    accountCode: string;
    appliedOn: Date;
    creatorId?: number | undefined;
    createdOn?: Date | undefined;
    entryType: LedgerEntryType;
    ledgerEntryId: number;
    amount: number;
}

export enum LedgerEntryType {
    Default = "Default",
    Suggestion = "Suggestion",
}

export interface LedgerResource {
    ledgerId: number;
    name: string;
    creatorId?: number | undefined;
    createdOn: Date;
    configuration: string;
}

export interface ManagementFeesAccountSplitsResource {
    orgCode: string;
    accountSplitId: number;
}

export interface Message {
    emailTo: string;
    subject: string;
    body: string;
}

export interface MessageQueueItemWithPayload {
    queueItemId: number;
    creatorId: number;
    createdOn: Date;
    queueItemType: QueueItemType;
    attempts: number;
    lastMessage?: string | undefined;
    startedOn?: Date | undefined;
    completedOn?: Date | undefined;
    payload: Message;
}

/** The minimum we need from a user to create a record. */
export interface MinimalUserInfo {
    displayName: string;
    email: string;
}

export enum NotificationSendStatus {
    Unknown = "Unknown",
    NotSent = "NotSent",
    Sent = "Sent",
}

export interface Organization {
    orgId: number;
    orgCode: string;
    name: string;
    accountingMethod: AccountingMethodType;
    metaJson?: string | undefined;
    meta?: OrganizationMeta | undefined;
    lagMonth: number;
    propertyTypeName: string;
    entrataPropertyId: string;
}

export interface OrganizationMeta {
    payrollSplit?: { [key: string]: number; } | undefined;
}

export interface OrgMappingLookup {
    id: number;
    name?: string | undefined;
    meta?: string | undefined;
}

export interface PayItem {
    payItemId: number;
    amount: number;
    amountEncrypted?: string | undefined;
    isBudget: boolean;
    payTypeId: number;
    payPeriodType: PayPeriodType;
}

export enum PayPeriodType {
    Unknown = "Unknown",
    Hourly = "Hourly",
    Weekly = "Weekly",
    Biweekly = "Biweekly",
    Monthly = "Monthly",
    Annual = "Annual",
}

export interface PayType {
    payTypeId: number;
    name: string;
    defaultPeriodType: PayPeriodType;
}

export interface PositionType {
    name: string;
    isService: boolean;
}

export interface PositionTypeResource {
    positionTypeId: number;
    name: string;
    isService: boolean;
}

export enum QueueItemStatus {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Completed = "Completed",
    All = "All",
}

export enum QueueItemType {
    Export = "Export",
    Message = "Message",
}

export interface RenewalOfferUploadItem {
    propertyCode: string;
    unitType: string;
    space: string;
    renewal: string;
}

export interface ReopenRequest {
    /** The workflow step to be reopened at. */
    stepId: number;
    /** The workflow to be reopened */
    workflowId: number;
}

export interface RequestAccessForm {
    rolesRequestedIds: number[];
    organizationsRequestedIds: number[];
    comment?: string | undefined;
}

export interface RevenueArea {
    revAreaId: number;
    accountCode?: string | undefined;
    areaType: RevenueAreaType;
    budgetYear: number;
    displayName: string;
    estimates: Estimate[];
    meta?: RevenueAreaMeta | undefined;
    name: string;
    numberOfBedrooms: number;
    orgId: number;
    parentRevAreaId?: number | undefined;
}

export interface RevenueAreaMeta {
    leaseInfo?: LeaseInfoMeta | undefined;
    flag?: string | undefined;
}

export enum RevenueAreaType {
    Unknown = "Unknown",
    UnitType = "UnitType",
    Unit = "Unit",
    AddOn = "AddOn",
    Self = "Self",
    NumberOfBedrooms = "NumberOfBedrooms",
}

export interface Role {
    roleId: number;
    name: string;
}

export interface Snapshot {
    snapshotId: number;
    description: string;
    viewLedgerId?: number | undefined;
    minAppliedOn?: Date | undefined;
    maxAppliedOn?: Date | undefined;
    creatorId?: number | undefined;
    createdOn?: Date | undefined;
}

export interface SystemConfig {
    id: number;
    actBudLedgerName?: string | undefined;
    budgetYear?: number | undefined;
    defaultCalculationView?: string | undefined;
    fpLedgerName?: string | undefined;
    payrollCashPayDaysPerMonth?: string | undefined;
    payrollExemptSalaryThreshold?: number | undefined;
    payrollSplitAccounts?: string | undefined;
    specialAccountsGainLossToLease?: string | undefined;
    specialAccountsGpr?: string | undefined;
    specialAccountsVacancyLoss?: string | undefined;
}

export interface UserSummary {
    userId: number;
    email: string;
    displayName: string;
}

export interface UserDetail extends UserSummary {
    accessMatrix: AccessMatrix;
}

export interface UserLedgerDetail {
    ledgerId: number;
    name: string;
    configuration: LedgerConfiguration;
    accountTree: LedgerAccountNode;
    ledgerEntries: LedgerEntry[];
    ledgerComments: LedgerComment[];
    /** This doesn't seem to get used? */
    isReadOnly: boolean;
}

export interface UserStateInfo extends UserDetail {
    features: string[];
    properties: string[];
    unknowns: string[];
}

export interface ViewInfoResource {
    viewId: number;
    name: string;
    ledgerId?: number | undefined;
}

export interface ViewSummary {
    viewId: number;
    ledgerId: number;
    name: string;
    sortIndex: number;
    workflowIds?: number[] | undefined;
}

export interface WorkflowSummary {
    workflowId: number;
    name: string;
}

export interface Workflow extends WorkflowSummary {
    relatedSteps: WorkflowStep[];
}

export interface WorkflowAction {
    actionType: WorkflowActionType;
    subTitle?: string | undefined;
    workflowId?: number | undefined;
    stepId?: number | undefined;
}

export enum WorkflowActionType {
    None = "None",
    Read = "Read",
    Edit = "Edit",
    Reopen = "Reopen",
}

export interface WorkflowEvent {
    action: WorkflowEventType;
    comments?: string | undefined;
}

export interface WorkflowEventDetail extends WorkflowEvent {
    ledgerId: number;
    orgId: number;
    originalBaseUrl: string;
    viewId: number;
    user: UserStateInfo;
}

export enum WorkflowEventType {
    Reject = "Reject",
    Approve = "Approve",
}

export interface WorkflowNotificationSummary {
    workflowNotificationId: number;
    workflowNotificationType: WorkflowNotificationType;
    workflowStateId?: number | undefined;
    queueItemId?: number | undefined;
    sendStatus: NotificationSendStatus;
}

export enum WorkflowNotificationType {
    NewWorkflow = "NewWorkflow",
    CompletedWorkflow = "CompletedWorkflow",
    PmsImport = "PmsImport",
}

export interface WorkflowState {
    workflowStateId: number;
    workflowId: number;
    orgId: number;
    viewId: number;
    stepId: number;
    stateCode: WorkflowStateCode;
    comments?: string | undefined;
    createdById: number;
    createdOn: Date;
    completedById?: number | undefined;
    completedOn?: Date | undefined;
}

export enum WorkflowStateCode {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Approved = "Approved",
    Rejected = "Rejected",
}

export interface WorkflowStateHistory {
    workflow: Workflow;
    states?: WorkflowState[] | undefined;
    readonly currentState?: WorkflowState | undefined;
    readonly previousStep?: WorkflowStep | undefined;
    readonly currentStep?: WorkflowStep | undefined;
    readonly nextStep?: WorkflowStep | undefined;
    readonly isComplete: boolean;
}

export interface WorkflowStep {
    stepId: number;
    amountsReadOnly: boolean;
    entryType: LedgerEntryType;
    exportOnComplete: boolean;
    helpInfo?: string | undefined;
    name: string;
    orderIndex: number;
    requireCommentOnChange: boolean;
    requireCommentOnSubmit: boolean;
    roleIds: number[];
    workflowId: number;
}

export interface WorkflowStepUpsertInfo extends WorkflowStep {
    helpInfoClear: boolean;
    helpFileData?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

export interface ExtendedApiResult {
  /** $count from the custom $count header */
  $count?: number;
  /** eTag from the ETag respnse header */
  $eTag?: string;
}

interface ExtendedApiWrapper extends ExtendedApiResult {
  data: any;
}